var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoPasswordBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 27,
    height: 27,
    rx: 13.5,
    fill: "#AAC4F9",
    stroke: "#AAC4F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 7a7 7 0 100 14 7 7 0 000-14zm1.457 10.849c-.36.142-.647.25-.862.324a2.274 2.274 0 01-.748.112c-.436 0-.776-.106-1.018-.32a1.03 1.03 0 01-.362-.81c0-.127.01-.257.027-.39a4.89 4.89 0 01.087-.45l.451-1.592c.04-.153.074-.298.101-.434.028-.136.04-.26.04-.375 0-.202-.041-.345-.125-.425-.085-.08-.244-.119-.482-.119-.116 0-.236.018-.358.054a5.053 5.053 0 00-.314.104l.12-.49c.294-.121.577-.224.847-.31s.524-.129.764-.129c.433 0 .768.106 1.003.315.234.209.352.48.352.815 0 .07-.008.191-.024.366a2.451 2.451 0 01-.09.48l-.45 1.588c-.036.128-.068.273-.098.436a2.31 2.31 0 00-.043.371c0 .211.046.355.141.432.094.076.258.115.49.115.11 0 .233-.02.371-.058.138-.038.237-.071.3-.1l-.12.49zm-.08-6.447c-.209.195-.46.292-.755.292-.294 0-.548-.097-.759-.292a.93.93 0 01-.315-.707.94.94 0 01.315-.708c.211-.197.465-.295.759-.295s.547.098.755.295c.21.196.315.433.315.708a.93.93 0 01-.315.707z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoPasswordBlue);
export default __webpack_public_path__ + "static/media/InfoPasswordBlue.b644629b59f939457d7b88b2706cc99a.svg";
export { ForwardRef as ReactComponent };